<div class="wrapper" *ngIf="router.url !== '/style-guide'; else styleGuideSection">
  @if (!isHeaderHidden()) {
    <app-header></app-header>
  }

  <div class="d-flex flex-row flex-grow-1">
    @if (!isSidebarHidden()) {
      <div [ngClass]="isCollapsed ? 'sidebar-wrapper collapsed' : 'sidebar-wrapper expanded'">
        <app-sidebar [isCollapsed]="isCollapsed" (collapsedChange)="toggleSidebar($event)"></app-sidebar>
      </div>
    }

    <div class="d-flex flex-column flex-grow-1" style="min-width: 0">
      <main class="flex-grow-1 py-3" [class.bg-body-tertiary]="!isFooterHidden()" [class.print-route-main]="isFooterHidden()">
        <div class="main-content-inner" [class.full-width]="isFullWidthPage() || isFooterHidden()">
          <router-outlet></router-outlet>
        </div>
      </main>

      @if (!isFooterHidden()) {
        <app-footer class="px-0"></app-footer>
      }
    </div>
  </div>
</div>

<ng-template #styleGuideSection>
  <router-outlet></router-outlet>
</ng-template>

<app-spinner></app-spinner>

@if (showAssistant && !isChatOpen) {
  <button type="button" class="ai-chat-launcher" aria-label="Open Truckit Assistant" (click)="openChat()">
    <span class="ai-chat-launcher__pulse" aria-hidden="true"></span>
    <i class="bi bi-stars ai-chat-launcher__icon" aria-hidden="true"></i>
  </button>
}

@if (showAssistant && hasOpenedChat) {
  <ai-chat
    [visible]="isChatOpen"
    [attr.user-name]="userName"
    [attr.provider-id]="providerId"
    [attr.api-endpoint]="assistantQueryUrl"
    [attr.suggest-endpoint]="assistantSuggestUrl"
    [attr.response-type]="assistantResponseType"
    (close)="closeChat()"
  ></ai-chat>
}
